const getUpdatedValue = (old, updated) => (updated ? updated : old);

export default getUpdatedValue;
